<template>
  <div v-if="notification.show"
        class="vr360-notification"
        :class="notificationType">
    <div class="vr360-notification__cont">
      <i class="vr360-notification__cont__icon vr360-notification__cont__icon--error">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.412 12.625l11.25-11.25" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
          <path d="M1.413 1.375l11.25 11.25" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </i>

      <i class="vr360-notification__cont__icon vr360-notification__cont__icon--success">
        <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6.2963L6 12L16 1" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <span class="vr360-text-reg vr360-notification__cont__text">{{ notification.message }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Notification",
  methods: {
    ...mapActions({
      hideNotification: "hideNotification"
    })
  },
  watch: {
    "notification.show"(val) {
      if (val) {
        setTimeout(() => {
          this.hideNotification();
        }, 2000);
      }
    }
  },
  computed: {
    ...mapGetters({
      notification: "notification"
    }),
    notificationType() {
      switch (this.notification.type) {
        case "success":
          return { "vr360-notification--success": true };

        case "error":
          return { "vr360-notification--error": true };
      }
    }
  }
};
</script>

<style lang="scss">
</style>
